import React from 'react';
import { Checkbox, Form } from 'antd';
import { FormattedMessage } from 'react-intl';
import styles from './FilterAryaSearch.module.scss';
import message from '../../Containers/CandidateFilters/CandidateFiltersMessage';


const FilterAryaSearch = props => {
  const { form, candidateCollapsedFilters, inlineStyles, candidateContext } = props;

  const tags =
    candidateContext === 'segment'
      ? [
          { label: <FormattedMessage {...message.includedLabel} />, value: 'shortlisted' },
          { label: <FormattedMessage {...message.removedLabel} />, value: 'rejected' },
          { label: <FormattedMessage {...message.viewedByMe} />, value: 'viewedByMe' },
          { label: <FormattedMessage {...message.viewedByOthersLabel} />, value: 'viewedByOthers' },
          { label: <FormattedMessage {...message.contactedLabel} />, value: 'contacted' },
        ]
      : [
          { label: <FormattedMessage {...message.shortlistedLabel} />, value: 'shortlisted' },
          { label: <FormattedMessage {...message.rejectedLabel} />, value: 'rejected' },
          { label: <FormattedMessage {...message.viewedByMe} />, value: 'viewedByMe' },
          { label: <FormattedMessage {...message.viewedByOthersLabel} />, value: 'viewedByOthers' },
          { label:  <FormattedMessage {...message.contactedLabel} />, value: 'contacted' },
        ];

  const collapsedFilterField = 'collapsedFilter';

  const selectedKeys = form.getFieldValue(collapsedFilterField) || [];

  const isAllSelected = tags.length === selectedKeys.length;

  const onCheckAllChange = e => {
    if (e.target.checked) form.setFieldsValue({ [collapsedFilterField]: tags.map(tag => tag.value) });
    else form.setFieldsValue({ [collapsedFilterField]: [] });
  };

  return (
    <div className={styles.candidateFilterPopoverContent} style={inlineStyles}>
      <Form>
        <div className={styles.candidateFilterPopoverContent} style={inlineStyles}>
          <div className={styles.candidateFilterPopoverContentHeader}><FormattedMessage {...message.collapseCandidatesLabel} /></div>
          <Form.Item className={styles.aryaFilterFormItem}>
            <Checkbox
              onChange={onCheckAllChange}
              checked={isAllSelected}
              key="selectAll"
              data-testid="selectAll-checkbox"
            >
              <FormattedMessage {...message.selectAllLabel} />
            </Checkbox>
          </Form.Item>
          <Form.Item>
            <div className="candidate-filter-tags">
              <div className={styles.tagFilterPopoverCheckboxes}>
                <div className={styles.aryaSearchCheckboxGroup}>
                  {form.getFieldDecorator('collapsedFilter', { initialValue: candidateCollapsedFilters })(
                    <Checkbox.Group>
                      {tags.map(tag => (
                        <Checkbox value={tag.value} key={tag.value}>
                          {tag.label}
                        </Checkbox>
                      ))}
                    </Checkbox.Group>
                  )}
                </div>
              </div>
            </div>
          </Form.Item>
        </div>
      </Form>
    </div>
  );
};

export default FilterAryaSearch;
